
export const initialValues = {
  departmentName: "",
  departmentCode: "",
  costCenter: "",
  divisionId: "",
  activeStatus: 1,
}